<template>
  <div class="footer">
    <div class="wrap">
      <div class="footernav">
        <div class="f_logo">
          <img src="../img/logo2.png" alt="" />
          <!-- <p class="address">COMDOTPRO TECHNOLOGY PRIVATE LIMITED</p> -->
        </div>
        <div class="r">
          <!-- <p style="margin-bottom: 40px">H E L P</p> -->
          <!-- <Nav :type="'column'" class="rnav" :hrefList="hrefList"></Nav> -->
          <div class="r_line1">
            <p>Customer care number: +1 716-503-7987</p>
            <p>Customer care email ID:contact@baatlive.com</p>
          </div>
          <div class="r_line2">BAAT PRIVATE LIMITED</div>
        </div>
      </div>

      <div class="footerinfo">
        <p>© {{ CurrentYean }} BAAT All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav/Nav.vue';
export default {
  data() {
    return {
      hrefList: [
        'About Us',
        'Contact Us',
        'TERMS AND CONDITIONS',
        'Privacy Policy',
      ],
      CurrentYean: '--',
    };
  },
  created() {
    // 获取当前年
    const yean = new Date().getFullYear();
    this.CurrentYean = yean;
  },
  components: {
    Nav,
  },
};
</script>

<style lang="scss" scoped src="./footer.scss">
</style>